import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE as PACKAGE_NAMESPACE } from '../../constants';

export const NAMESPACE = `${PACKAGE_NAMESPACE}/purchase`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const INITIALIZE_WITH_PLANS = `${NAMESPACE}/INITIALIZE_WITH_PLANS`;
export const REMOVE_CROSS_BROWSER_CONFIG = `${NAMESPACE}/REMOVE_CROSS_BROWSER_CONFIG`;
export const SET_WEB_AND_MOBILE_TESTING_TAB = `${NAMESPACE}/SET_WEB_AND_MOBILE_TESTING_TAB`;
export const UPDATE_PRODUCT_CONFIG = `${NAMESPACE}/UPDATE_PRODUCT_CONFIG`;
export const FETCH_MONTHLY_USAGE = createApiNamespacedConstants('FETCH_MONTHLY_USAGE');
